/**
 * 统一请求方法封装
 * 为 axios 实例提供 get/post/put/delete/request 方法
 *
 * 注意：拦截器已统一解包 ResData，调用方拿到的直接是业务数据 T，无需再取 .data
 */
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

/**
 * 为 axios 实例创建统一的请求方法
 * @param client axios 实例
 * @returns 封装好的请求方法对象
 */
export function createRequest(client: AxiosInstance) {
  return {
    /**
     * GET 请求
     */
    get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
      return client.get(url, config).then((res) => res as unknown as T);
    },

    /**
     * POST 请求
     */
    post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
      return client.post(url, data, config).then((res) => res as unknown as T);
    },

    /**
     * PUT 请求
     */
    put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
      return client.put(url, data, config).then((res) => res as unknown as T);
    },

    /**
     * DELETE 请求
     */
    delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
      return client.delete(url, config).then((res) => res as unknown as T);
    },

    /**
     * PATCH 请求
     */
    patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
      return client.patch(url, data, config).then((res) => res as unknown as T);
    },

    /**
     * 通用请求方法
     */
    request<T>(config: AxiosRequestConfig): Promise<T> {
      return client.request(config).then((res) => res as unknown as T);
    },
  };
}
